<template>
  <div class="bigBoxBody">
    <div class="headerBox">
      <div class="logoBox">
        <div style=" display: flex; align-items: center;">
          <img style="height:40px;" src="../../assets/images/logo.png" alt />
        </div>
        <div class="logoText">气候极端事件风险防范决策支持系统</div>
      </div>
      <div class="item-box">
        <router-link to="/heat">
          <div :class="[active == 4 ? 'item item1 active' : 'item item1']" @click="getPage(4)">极端高温</div>
        </router-link>
        <router-link to="/cold">
          <div :class="[active == 5 ? 'item  active' : 'item ']" @click="getPage(5)">极端低温</div>
        </router-link>
        <router-link to="/rain">
          <div :class="[active == 1 ? 'item  active' : 'item ']" @click="getPage(1)">极端降水</div>
        </router-link>
        <router-link to="/dry">
          <div :class="[active == 2 ? 'item  active' : 'item ']" @click="getPage(2)">极端干旱</div>
        </router-link>
        <router-link to="/typhoon">
          <div :class="[active == 3 ? 'item  active' : 'item ']" @click="getPage(3)">台风</div>
        </router-link>
        <router-link to="clime">
          <div :class="[active == 6 ? 'item  active' : 'item ']" @click="getPage(6)">气候变化</div>
        </router-link>
        <router-link to="/manger">
          <div :class="[active == 7 ? 'item  active' : 'item ']" @click="getPage(7)">系统管理</div>
        </router-link>
        <div class="item" @click="loginOut">退出登录</div>
      </div>
    </div>
    <div style="display:flex;  height: 93vh; width: 100vw;">
      <!-- <div style="width:100px;height:100vh;background-color:#32709F">
        <router-link to="/heat">
          <div :class="[active == 4 ? 'item  active' : 'item ']" @click="getPage(4)">高温</div>
        </router-link>
        <router-link to="/cold">
          <div :class="[active == 5 ? 'item  active' : 'item ']" @click="getPage(5)">低温</div>
        </router-link>
        <router-link to="/rain">
          <div :class="[active == 1 ? 'item  active' : 'item ']" @click="getPage(1)">降水</div>
        </router-link>
        <router-link to="/dry">
          <div :class="[active == 2 ? 'item  active' : 'item ']" @click="getPage(2)">干旱</div>
        </router-link>
        <router-link to="/typhoon">
          <div :class="[active == 3 ? 'item  active' : 'item ']" @click="getPage(3)">台风</div>
        </router-link>
        <router-link to="clime">
          <div :class="[active == 6 ? 'item  active' : 'item ']" @click="getPage(6)">气候变化</div>
        </router-link>
        <router-link to="/manger">
          <div :class="[active == 7 ? 'item  active' : 'item ']" @click="getPage(7)">系统管理</div>
        </router-link>
        <div class="item" @click="loginOut">退出登录</div>
      </div>-->
      <div class="view-box">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      map: "",
      active: 1
    };
  },
  mounted() {
    this.initDate();
  },
  methods: {
    loginOut() {
      this.$store.commit("setLogin", false);
      Cookies.remove("isNccLogin");
      this.$router.push("/");
    },
    initDate() {},
    getPage(e) {
      // console.log(e);
      this.active = e;
      // console.log(this.active);
    }
  }
};
</script>

<style>
.loginoutBtn {
  width: 100px;
  height: 50px;
  display: flex;
  align-content: center;
  align-items: center;
}
.my-layer-item {
  text-align: center;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
a {
  text-decoration: none;
  color: black;
}
.headerBox {
  width: 100vw;
  height: 50px;
  background-color: #32709f;
  display: flex;
  justify-content: space-between;
  /* background-image: url("../../assets/images/bg.jpg"); */
}
.logoBox {
  /* font-size: 20px; */

  /* line-height: 100px; */
  padding-left: 25px;
  height: 50px;
  padding: 5px 5px;
  display: flex;
  align-items: center;
}
.logoText {
  font-size: 20px;
  font-weight: 700;
  color: #103a86;
  margin-left: 30px;
  -webkit-text-stroke: 1px rgb(255, 255, 255);
}
.item-box {
  height: 50px;
  /* margin-top: 20px; */
  display: flex;
}

.item {
  width: 100px;
  height: 50px;
  /* background-color: #3cbaf0; */
  /* margin-right: 10px; */
  line-height: 50px;
  font-size: 18px;
  text-align: center;
  /* border: 1px solid #274986; */
  /* font-weight: 600; */
  /* margin-bottom: 10px; */
  color: white;
  font-size: 12px;
}

/* .item1 {
  border-radius: 10px 0 0 0;
} */

.active {
  /* background-color: #1a69cf; */
  color: white;
  font-size: 20px;
  font-weight: 700;
  border-bottom: 5px solid #029686;
}

.view-box {
  width: 90vw;
  /* height: 93vh;
   */
  height: calc(100vh - 50px);
}
.popper__arrow {
  left: 80px !important;
}
.el-picker-panel {
  left: -40px !important;
}
</style>